import { Box, Typography, styled } from "@mui/material"

import Button from "components/ui/Button"
import { colors } from "theme"

export const Header = styled(Box)(() => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
  width: "100%",
}))

export const Title = styled(Typography)(() => ({
  color: colors.black,
  fontSize: "1.25rem",
  fontWeight: "500",
  lineHeight: "1.6",
}))

export const Description = styled(Typography)(() => ({
  color: colors.black,
  fontSize: "0.875rem",
  fontWeight: "400",
  lineHeight: "1.6",
  margin: "7px 0",
  textAlign: "justify",
}))

export const Content = styled(Box)(() => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
  marginTop: "14px",
  width: "100%",
}))

export const Toggle = styled(Button)(({ theme }) => ({
  color: theme.palette.common.black,
  borderRadius: "21px",
  display: "block",
  fontWeight: "normal",
  textAlign: "center",
  margin: "0 5px",
  width: "50%",
}))

export const Accept = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.common.white,
  borderRadius: "21px",
  display: "block",
  fontWeight: "normal",
  textAlign: "center",
  margin: "0 5px",
  width: "50%",
}))
